<div class="modal-body" *ngIf="!isTemplateRef()">
    <div class="message">{{bodyContent.message}}</div>
    <div class="sub-message" *ngIf="bodyContent.subMessage">{{bodyContent.subMessage}}</div>
</div>
<ng-container *ngIf="isTemplateRef()">
    <ng-container *ngTemplateOutlet="this.bodyContent">
    </ng-container>
</ng-container>